import React from 'react';
import styled from 'styled-components';
import DeviceFrame from './ui/DeviceFrame';
import Badge from './ui/Badge';
import { getProject } from '../data/projects';

const Stage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 0.9;

  .layer {
    position: absolute;
    transition: transform 0.4s ease;
  }

  @media (hover: hover) and (min-width: 960px) {
    &:hover .layer-main {
      transform: translate(-6px, -4px);
    }
    &:hover .layer-phone {
      transform: translate(-4px, 6px);
    }
    &:hover .layer-side {
      transform: translate(6px, 4px);
    }
  }
`;

const Main = styled.div`
  top: 0;
  right: 0;
  width: 86%;
  z-index: 1;
`;

const Phone = styled.div`
  left: 0;
  bottom: 0;
  width: 27%;
  z-index: 3;
`;

const Side = styled.div`
  right: 4%;
  bottom: 2%;
  width: 54%;
  z-index: 2;
`;

const Caption = styled.span`
  position: absolute;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.4rem 0.35rem 0.75rem;
  border-radius: var(--radius-pill);
  background: rgba(7, 12, 22, 0.92);
  border: 1px solid var(--border-strong);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-1);
  white-space: nowrap;
  box-shadow: var(--shadow-1);
`;

const MainCaption = styled(Caption)`
  top: 34px;
  right: 12px;
`;

const SideCaption = styled(Caption)`
  right: 10px;
  bottom: -14px;
`;

const PhoneCaption = styled(Caption)`
  left: 50%;
  bottom: -14px;
  transform: translateX(-50%);
`;

const HeroMontage: React.FC = () => {
  const likeFamily = getProject('likefamily');
  const rb = getProject('rbcarcare');
  const raices = getProject('raicesypatitas');

  return (
    <Stage>
      <Main className="layer layer-main">
        <DeviceFrame
          src={likeFamily.images.card.src}
          alt={likeFamily.images.card.alt}
          width={likeFamily.images.card.width}
          height={likeFamily.images.card.height}
          priority
        />
        <MainCaption>
          {likeFamily.name} <Badge variant="live" />
        </MainCaption>
      </Main>

      <Side className="layer layer-side">
        <DeviceFrame
          src={raices.images.card.src}
          alt={raices.images.card.alt}
          width={raices.images.card.width}
          height={raices.images.card.height}
          priority
        />
        <SideCaption>
          {raices.name} <Badge variant="coming-soon" />
        </SideCaption>
      </Side>

      <Phone className="layer layer-phone">
        <DeviceFrame
          variant="phone"
          src={rb.images.mobile.src}
          alt={rb.images.mobile.alt}
          width={rb.images.mobile.width}
          height={rb.images.mobile.height}
          priority
        />
        <PhoneCaption>
          {rb.name} <Badge variant="live" />
        </PhoneCaption>
      </Phone>
    </Stage>
  );
};

export default HeroMontage;
